const app_config = {
    LANDING_PAGE_FRONT: process.env.LANDING_PAGE_FRONT,
};

export default app_config;
